import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
// router setup
import routes from "./routes";
import store from "../store";
import { ensureHubSunsetNoticeFetched, isHubSunsetFeatureEnabled, isLegacyLaunchPageHost, shouldForceHubSunsetRoute, syncHubSunsetFromPlatform, } from "../helper/hubSunset";
import { hasStoredAccessToken } from "../helper/sessionRedirect";
import { getCachedSsoConfig, loadSsoConfig } from "../helper/sso";
import { isAgencySocialSite } from "../config/agencyRuntime";
function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];
    if (!subsequentMiddleware)
        return context.next;
    return (...parameters) => {
        context.next(...parameters);
        const nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware({ ...context, next: nextMiddleware });
    };
}
const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior(to, _from, _savedPosition) {
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    },
    linkExactActiveClass: "nav-item active",
    linkActiveClass: "nav-item active",
});
router.beforeEach(async (to, from, next) => {
    if (typeof window !== "undefined" && isAgencySocialSite() && to.name === "Login") {
        return next({ name: "AgencyLogin" });
    }
    if (typeof window !== "undefined" &&
        (hasStoredAccessToken() || sessionStorage.getItem("chat_launch_notice"))) {
        const cfg = getCachedSsoConfig() || (await loadSsoConfig().catch(() => null));
        if (cfg) {
            syncHubSunsetFromPlatform(cfg.platform ?? null);
        }
        // BE bật sunset mà sessionStorage chưa có notice (user đã login từ trước) → tự fetch.
        if (isLegacyLaunchPageHost() &&
            isHubSunsetFeatureEnabled() &&
            hasStoredAccessToken() &&
            !sessionStorage.getItem("chat_launch_notice") &&
            to.name !== "HubSunset" &&
            to.name !== "Login" &&
            to.name !== "AgencyLogin") {
            await ensureHubSunsetNoticeFetched().catch(() => null);
        }
    }
    if (store.getters.isAuthenticated &&
        shouldForceHubSunsetRoute(String(to.name || ""))) {
        return next({ name: "HubSunset" });
    }
    const vuex = localStorage.getItem("vuex");
    if (vuex) {
        const auth = JSON.parse(vuex).auth.user;
        const user = auth?.user ?? null;
        if (user &&
            auth.isAuthenticated &&
            to.name !== "Update user page" &&
            to.name != "Login" &&
            to.name != "AgencyLogin" &&
            to.name != "ChatDomainLaunch" &&
            to.name != "LegacySocialRedirect" &&
            user &&
            user.profile_updated === 0) {
            return next(`update-user`);
        }
    }
    const metaMw = to.meta.middleware;
    if (metaMw) {
        const middleware = Array.isArray(metaMw) ? metaMw : [metaMw];
        const context = { from, next, to, router };
        const nextMiddleware = nextFactory(context, middleware, 1);
        return middleware[0]({ ...context, next: nextMiddleware });
    }
    return next();
});
export default router;
